import {FreightTypeSelectorProps, freightTypesSelector, useGetAllFreightTypesQuery} from "@ots-frontend/ots-data";
import {BaseFreightTypeSelect, BaseFreightTypeSelectProps} from "./BaseFreightTypeSelect";
import {useMemo} from "react";

export type FreightTypeSelectProps = Omit<BaseFreightTypeSelectProps, "entities" | "loading"> & {
    selector?: FreightTypeSelectorProps
}

export const FreightTypeSelect = (props: FreightTypeSelectProps) => {
    const {selector, ...rest} = props;

    const selectFreightTypes = useMemo(() => {
        return freightTypesSelector();
    }, []);

    const {freightTypes, isLoading} = useGetAllFreightTypesQuery(selector?.regionId, {
        selectFromResult: (result) => ({
            freightTypes: selectFreightTypes(result, selector),
            isLoading: result.isLoading
        })
    });

    return <BaseFreightTypeSelect entities={freightTypes} loading={isLoading} {...rest} />;
};
